export default __webpack_public_path__ + "images/XC.22527c1.png";